export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/new_courses_promo_bg-6f242143b3720613585da85c62021fb4.svg";